import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes } from "@fortawesome/free-solid-svg-icons";
import OrderSearch from "../common/OrderSearch"; 

export default function SelectOrders({
  open,
  onClose,
  onDone, // Callback to return selected order numbers
  accountNumber,
  title = "Select Orders",
  maxSelection = null, // Optional limit on number of orders
}) {
  const [orderInput, setOrderInput] = useState("");
  const [isOrderValid, setIsOrderValid] = useState(false);
  const [orders, setOrders] = useState([]); // Array of order objects
  const [selectedOrders, setSelectedOrders] = useState([]); // Array of selected order numbers

  const handleOrderData = (orderData) => {
    if (orderData && !orders.some(order => order.orderNumber === orderData.orderNumber)) {
      // Add new order object to the list
      setOrders(prev => [...prev, orderData]);
      // Clear the search input
      setOrderInput("");
    }
  };

  const handleRemoveOrder = (orderNumber) => {
    setOrders(prev => prev.filter(order => order.orderNumber !== orderNumber));
    setSelectedOrders(prev => prev.filter(id => id !== orderNumber));
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedOrders(orders.map(order => order.orderNumber));
    } else {
      setSelectedOrders([]);
    }
  };

  const handleSelectOrder = (orderNumber) => {
    setSelectedOrders(prev => {
      if (prev.includes(orderNumber)) {
        return prev.filter(id => id !== orderNumber);
      } else {
        if (maxSelection && prev.length >= maxSelection) {
          return prev; // Don't add if max limit reached
        }
        return [...prev, orderNumber];
      }
    });
  };

  const handleDone = () => {
    onDone(selectedOrders);
    handleClose();
  };

  const handleClose = () => {
    // Reset state when closing
    setOrders([]);
    setSelectedOrders([]);
    setOrderInput("");
    onClose();
  };

  const isAllSelected = orders.length > 0 && selectedOrders.length === orders.length;
  const isIndeterminate = selectedOrders.length > 0 && selectedOrders.length < orders.length;

  if (!open) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={handleClose}></div>
      <div className="modal-card" style={{ 
        width: "95vw", 
        height: "90vh", 
        maxWidth: "none", 
        maxHeight: "none",
        display: "flex",
        flexDirection: "column"
      }}>
        <header className="modal-card-head" style={{ flexShrink: 0 }}>
          <p className="modal-card-title">
            {title}
            {maxSelection && (
              <span className="tag is-light is-small ml-2">
                Max {maxSelection} orders
              </span>
            )}
          </p>
          <button className="delete" onClick={handleClose}></button>
        </header>
        
        <section className="modal-card-body" style={{ 
          flex: 1, 
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }}>
          <div className="mb-4" style={{ flexShrink: 0 }}>
            <OrderSearch
              value={orderInput}
              onChange={(e) => setOrderInput(e.target.value)}
              isValidated={setIsOrderValid}
              onOrderData={handleOrderData}
              accountNumber={accountNumber}
              placeholder="Search and add orders..."
            />
          </div>

          {orders.length > 0 ? (
            <div className="table-container" style={{ 
              flex: 1, 
              overflowY: "auto",
              border: "1px solid #dbdbdb",
              borderRadius: "4px"
            }}>
              <table className="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>
                      <label className="checkbox">
                        <input
                          type="checkbox"
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                          ref={input => {
                            if (input) input.indeterminate = isIndeterminate;
                          }}
                        />
                      </label>
                    </th>
                    <th>Order Number</th>
                    <th>Client Name</th>
                    <th>Project</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr key={order.orderNumber}>
                      <td>
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            checked={selectedOrders.includes(order.orderNumber)}
                            onChange={() => handleSelectOrder(order.orderNumber)}
                            disabled={
                              maxSelection && 
                              !selectedOrders.includes(order.orderNumber) && 
                              selectedOrders.length >= maxSelection
                            }
                          />
                        </label>
                      </td>
                      <td>
                        <strong>#{order.orderNumber}</strong>
                      </td>
                      <td>
                        <span className="tag is-small is-info">
                          {order.name}
                        </span>
                      </td>
                      <td>
                        <span className=" is-small ">
                          {order.project}
                        </span>
                      </td>
                      <td>
                        <button
                          className="button is-small is-danger is-outlined"
                          onClick={() => handleRemoveOrder(order.orderNumber)}
                          title="Remove order"
                        >
                          <span className="icon is-small">
                            <FontAwesomeIcon icon={faTrash} />
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="has-text-centered py-6" style={{ 
              flex: 1, 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center" 
            }}>
              <p className="has-text-grey">
                No orders added yet. Search for orders above to get started.
              </p>
            </div>
          )}
        </section>

        <footer className="modal-card-foot" style={{ flexShrink: 0 }}>
          <button className="button" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="button is-primary"
            onClick={handleDone}
            disabled={selectedOrders.length === 0}
          >
            Done ({selectedOrders.length})
          </button>
        </footer>
      </div>
    </div>
  );
}